import { FC, useEffect, useState } from "react";
import { getStaticUrl } from "../../../utils";
import { SectionHeader } from "../../../components/layout/SectionHeader";
import { SectionHeaderButton } from "../../../components/layout/SectionHeaderButton";
import { PhotoCarousel } from "../../../components/PhotoCarousel";

interface NewsPhotosProps {
    linkUrl?: string;
    photos?: string[];
}

export const NewsPhotos: FC<NewsPhotosProps> = ({
    linkUrl,
    photos,
}) => {
    const [images, setImages] = useState(photos || []);

    useEffect(() => {
        setImages(photos || []);
    }, [photos]);

    if (!images?.length) {
        return null;
    }

    return (
        <>
            <SectionHeader title="Фото" actionButton={<SectionHeaderButton title="Смотреть весь альбом" url={linkUrl} />} />
            <PhotoCarousel
                images={images.map(i => getStaticUrl(i))}
            />
        </>
    );
}